import { memo } from 'react';
import { OptionComp, OptionCompProps } from '../OptionComp';
import { useTranslation } from 'react-i18next';

export default memo(function WreckerPrice() {
    // hook
    const { t } = useTranslation();

    // const
    const OtherOption: OptionCompProps[] = [
        {
            title: t('price_list.title_section.other_1'),
            data: [
                {
                    fieldName: '対人',
                    value: '無制限'
                },
                {
                    fieldName: '対物',
                    value: '無制限'
                },
                {
                    fieldName: '搭乗者傷害',
                    value: '最大500万円※'
                }
            ],
            textDecoration: t('price_list.text_decoration.other_1'),
            descriptionList: [t('sentences.other_price_1_des_1')],
            specialNote: [t('sentences.other_price_1_note_1'), t('sentences.other_price_1_note_2')]
        },
        {
            title: t('price_list.title_section.other_2'),
            data: [
                {
                    fieldName: '故障時',
                    value: '無償'
                },
                {
                    fieldName: '事故・破損時',
                    value: '有償（約800円/km）※ ',
                    valueClass: 'whitespace-nowrap'
                },
                {
                    fieldName: 'バッテリー上がり',
                    value: '個別対応'
                }
            ],
            textDecoration: t('price_list.text_decoration.other_2'),
            descriptionList: [t('sentences.other_price_2_des_1'), t('sentences.other_price_2_des_2')],
            specialNote: [t('sentences.other_price_2_note_1'), t('sentences.price_contain_tax')],
            hash: 'towing-service'
        }
    ];

    return (
        <>
            {
                OtherOption.length > 0 && OtherOption.map((item, idx) => (
                    <OptionComp option={item} key={idx} />
                ))
            }
        </>
    );
});
